var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 261.879,
    height: 257.131,
    viewBox: "0 0 261.879 257.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shadwork-logo",
    transform: "translate(0.437 6.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M0,.16a359.543,359.543,0,0,1,60.728,77.4A295.216,295.216,0,0,1,95.01,167.647,242.639,242.639,0,0,0,95.6,80.3,254.076,254.076,0,0,0,78.359,23.51Z",
    transform: "translate(10.159 3.941)",
    fill: "#5ea6c5",
    stroke: "#0d6986",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M18.455,70.013c11.924,2.721,23.7,8.3,35.164,16.663,22.946,16.66,44.245,44.3,62.611,81.244-2.965-7.531-7.088-17.6-12.251-28.948q-11.71-25.2-24.561-47.071C65.4,68.412,37.814,32.356,0,.16H0q5.213,16.1,10.445,36.15C13.508,48.078,16.158,59.469,18.455,70.013Z",
    transform: "translate(24.87 62.077) rotate(-30)",
    fill: "#7fc6e6",
    stroke: "#0d6986",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M192.059,150.591c-40.761-35.84-88.5-58.976-138.809-67.276a230.049,230.049,0,0,1,119.3,11.142Z",
    transform: "translate(63.969 87.377)",
    fill: "#7fc6e6",
    stroke: "#0d6986",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M125.172,169.394a209.616,209.616,0,0,0-10.595-46.2A227.016,227.016,0,0,0,63.85,41c4.7,3.874,10.974,9.3,18.038,16.036A369.038,369.038,0,0,1,111.25,89.264c14.593,18.386,37.272,54.565,57.5,104.094h0c-6.684-4.416-14.185-9.012-22.5-13.531C138.919,175.85,131.856,172.39,125.172,169.394Z",
    transform: "translate(44.541 1.25) rotate(-16)",
    fill: "#5ea6c5",
    stroke: "#0d6986",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M0,202.946C30.954,180.3,56.346,155.71,75.58,129.752c18.986-25.639,31.856-52.4,38.317-79.692a249.078,249.078,0,0,1,4.746,61.792,254.173,254.173,0,0,1-8.964,55.447Z",
    transform: "translate(66.083 19.39) rotate(19)",
    fill: "#7fc6e6",
    stroke: "#0d6986",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M0,160.037c47.347-41.688,102.387-68.1,160.112-76.833A401.93,401.93,0,0,0,37.3,85.9Q18.682,122.987,0,160.037Z",
    transform: "translate(0.01 47.463)",
    fill: "#5ea6c5",
    stroke: "#0d6986",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressImage);
export default __webpack_public_path__ + "static/media/address_image.6646a2106361b0c228c9c8ace218e5d8.svg";
export { ForwardRef as ReactComponent };